import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {Submission} from '../shared.types';

@Component({
    selector: 'app-contract-present-to-market',
    templateUrl: './contract-present-to-market.component.html',
    styleUrls: ['./contract-present-to-market.component.scss']
})
export class ContractPresentToMarketComponent implements OnInit {

    config: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '9.5rem',
        minHeight: '9.5rem',
        placeholder: 'Enter text here...',
        translate: 'no',
        customClasses: []
    };
    htmlContent:            any;
    reinsurerSelected:      boolean;
    reinsurerList:          any;
    reinsurerCheckedList:   any;
    step = 1;
    proceed:                boolean = false;

    constructor(public dialogRef: MatDialogRef<ContractPresentToMarketComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        this.reinsurerSelected = false;
        this.reinsurerList = [
            {id: 1, value: 'Reinsurer 1', isSelected: true, participation: true, online: true},
            {id: 2, value: 'Reinsurer 2', isSelected: true, participation: true, online: true},
            {id: 3, value: 'Reinsurer 3', isSelected: false,  participation: true, online: false}
        ];

        this.getCheckedItems();
    }

    checkUncheckAll() {
        console.log( this.reinsurerSelected);
        this.reinsurerSelected = !this.reinsurerSelected;
        this.reinsurerList.forEach((element) => {
            element.isSelected = this.reinsurerSelected;
        });

        this.getCheckedItems();
    }

    isAllSelected() {
        this.reinsurerSelected = this.reinsurerList.every((item: any) => {
            return item.isSelected === true;
        });
        this.getCheckedItems();
    }

    getCheckedItems() {
        this.reinsurerCheckedList = [];
        this.reinsurerList.forEach((element) => {
            if (element.isSelected) {
                this.reinsurerCheckedList.push(element);
            }
        });
        this.reinsurerCheckedList = JSON.stringify(this.reinsurerCheckedList);
    }

    private *_getSubmission(): Iterable<Submission> {
      let seed = 0;
      yield new Submission(++seed, 'Quote', 'Mar 11, 2019 @ 12:04', 'Mar 11, 2019 @ 12:04', 3, 'Jane Doe' );
    }

    ok() {
      const Submissions  = Array.from(this._getSubmission());
      this.dialogRef.close({ isOk: true, Submissions});
    }

    cancel() {
        this.dialogRef.close({isCancel: true});
    }

    selectStep(value) {
        this.step = value;
    }

}
